import classNames from 'classnames'
import { Markdown } from '../../base/Markdown'
import { getFileIconByFileTypeOrMimeType } from '../utils/file'
import { Icon } from '../../base/Icon'

export interface KnowledgeContent {
  file_id?: string
  file_name?: string
  mimetype?: string
  file_type?: number
  download_url?: string
  chunk_id?: string
  content?: string
  keywords?: string[]
  datastore_id?: string
  datastore_name?: string
  relevance_score?: {
    keywords: number
    reranker: number
    vector: number
  }
}

export interface KnowledgeOutputProps {
  contents: KnowledgeContent[]
  openInAgent?: boolean
  onOpenKnowledgeCard?: (
    datastoreId?: string,
    fileId?: string,
    chunkId?: string,
    openInPageModal?: boolean,
    openInAgent?: boolean,
  ) => void
}

export function KnowledgeOutput(props: KnowledgeOutputProps) {
  const { contents, onOpenKnowledgeCard, openInAgent } = props

  return (
    <div>
      {contents.map((each = {}, index) => {
        const rankInfo = []

        if (each.relevance_score?.reranker) {
          rankInfo.push(`重排${each.relevance_score.reranker.toFixed(2)}分`)
        }
        if (each.relevance_score?.vector) {
          rankInfo.push(`语义${each.relevance_score.vector.toFixed(2)}分`)
        }
        if (each.relevance_score?.keywords) {
          rankInfo.push(`关键词${each.relevance_score.keywords.toFixed(2)}分`)
        }

        return (
          <div
            key={index}
            className={classNames('bg-[#ECEDF2] rounded-[8px] cursor-pointer', {
              'mb-[12px]': index !== contents.length - 1,
            })}
            onClick={() => {
              onOpenKnowledgeCard?.(
                each.datastore_id,
                each.file_id,
                each.chunk_id,
                false,
                openInAgent,
              )
            }}
          >
            <div className='flex  flex-1 justify-between align-center px-[12px] py-[10px]'>
              <p className='flex items-center'>
                <Icon
                  className='w-[20px] h-[24px] mr-[6px] h-[16px] shrink-0'
                  path={getFileIconByFileTypeOrMimeType(
                    each.mimetype!,
                    each.file_type,
                  )}
                />
                <div className='leading-[16px] truncate max-w-[200px]'>
                  {each.file_name}
                </div>
                {each.download_url && (
                  <a
                    className='shrink-0 ml-[4px] cursor-pointer w-[16px] [filter:invert(62%)_sepia(11%)_saturate(206%)_hue-rotate(202deg)_brightness(87%)_contrast(84%)]'
                    href={each.download_url}
                    download
                    onClick={e => e.stopPropagation()}
                  >
                    <Icon path='xiazairizhi.svg' className='w-[14px]' />
                  </a>
                )}
              </p>
              {!!each.datastore_id &&
                !!each.file_id &&
                !!each.datastore_name && (
                  <div
                    className='text-[12px]/[14px] flex items-center'
                    onClick={e => {
                      e.stopPropagation()
                    }}
                  >
                    <p className='max-w-[180px] truncate'>
                      <span className='c-[#8D8D99] op-[0.6]'>所属知识库:</span>
                      <span className='c-[#17171D] op-[0.8] ml-[4px]'>
                        {each.datastore_name}
                      </span>
                    </p>
                    <Icon
                      className='ml-[4px] w-[14px] h-[14px] cursor-pointer [filter:invert(62%)_sepia(11%)_saturate(206%)_hue-rotate(202deg)_brightness(87%)_contrast(84%)]'
                      path='super-link-1.svg'
                      onClick={() => {
                        onOpenKnowledgeCard?.(
                          each.datastore_id,
                          each.file_id,
                          each.chunk_id,
                          true,
                          openInAgent,
                        )
                      }}
                    />
                  </div>
                )}
            </div>

            <div className='bg-[#F6F6F9] p-[12px] rounded-[8px] break-all hover:bg-[#E6E6ED]'>
              {!!each.keywords && !!each.keywords.length && (
                <div className='color-[#8D8D99] leading-[20px] mb-[12px] text-[12px]'>
                  命中关键词
                  {each.keywords.map((each, index) => (
                    <span
                      className='border b-[#E1E1E5] px-[4px] py-[2px] rounded-[4px] ml-[8px] bg-white'
                      key={index}
                    >
                      {each}
                    </span>
                  ))}
                </div>
              )}

              <Markdown text={each.content ?? ''} />

              {!!rankInfo.length && (
                <div className='color-[#8D8D99] mt-[12px] text-[12px]'>
                  命中排名{index + 1}：{rankInfo.join('、')}
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
